var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 202,
    viewBox: "0 0 202 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 3",
    opacity: 0.202683,
    cx: 101,
    cy: 101,
    r: 101,
    transform: "matrix(0 1 1 0 0 0)",
    fill: "url(#paint0_linear_575_2818)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "london_flatline 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "london_flatline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M64.2009 90.9342L68.9011 86.1035L64.2009 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M64.2009 91.2042C64.131 91.2047 64.0638 91.1773 64.0141 91.1279C63.9094 91.0225 63.9094 90.8518 64.0141 90.7463L68.685 85.9157C68.7894 85.8154 68.954 85.8159 69.0576 85.917C69.1613 86.018 69.1669 86.1834 69.0704 86.2913L64.3702 91.122C64.3252 91.1686 64.2652 91.1977 64.2009 91.2042Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M68.9011 90.9342L64.2009 86.1035L68.9011 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M68.9009 91.2038C68.8284 91.2031 68.7591 91.1736 68.7082 91.1217L64.0372 86.291C63.9873 86.2414 63.9592 86.1737 63.9592 86.1032C63.9592 86.0326 63.9873 85.965 64.0372 85.9153C64.1421 85.8101 64.3119 85.8101 64.4168 85.9153L69.1169 90.746C69.2185 90.8527 69.2185 91.0208 69.1169 91.1275C69.0603 91.1848 68.9807 91.2129 68.9009 91.2038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M68.9011 90.9342L73.6013 86.1035L68.9011 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M68.901 91.2038C68.8309 91.205 68.7635 91.1775 68.7141 91.1275C68.6125 91.0208 68.6125 90.8527 68.7141 90.746L73.3851 85.9153C73.4344 85.8652 73.5017 85.8369 73.5719 85.8369C73.6421 85.8369 73.7094 85.8652 73.7588 85.9153C73.8102 85.9641 73.8393 86.0321 73.8393 86.1032C73.8393 86.1743 73.8102 86.2422 73.7588 86.291L69.0878 91.1216C69.0383 91.1721 68.9714 91.2016 68.901 91.2038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M73.6013 90.9342L68.9011 86.1035L73.6013 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M73.6012 91.2042C73.5287 91.2034 73.4594 91.1739 73.4085 91.122L68.7376 86.2913C68.641 86.1834 68.6466 86.018 68.7503 85.917C68.854 85.8159 69.0186 85.8154 69.1229 85.9157L73.7939 90.7463C73.8456 90.7962 73.8749 90.8651 73.8749 90.9371C73.8749 91.0091 73.8456 91.078 73.7939 91.1279C73.744 91.1807 73.6735 91.2086 73.6012 91.2042Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M73.6011 90.9342L78.2954 86.1035L73.6011 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M73.6013 91.204C73.531 91.2067 73.463 91.1789 73.4144 91.1277C73.3098 91.0223 73.3098 90.8516 73.4144 90.7462L78.1146 85.9156C78.2209 85.8322 78.3722 85.8409 78.4683 85.936C78.5644 86.0311 78.5754 86.1831 78.4941 86.2912L73.794 91.1219C73.7431 91.1738 73.6738 91.2033 73.6013 91.204Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M78.2954 90.9342L73.6011 86.1035L78.2954 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M78.3129 91.204C78.2419 91.2045 78.174 91.1746 78.1261 91.1219L73.4259 86.2912C73.3446 86.1831 73.3556 86.0311 73.4517 85.936C73.5478 85.8409 73.6991 85.8322 73.8054 85.9156L78.5056 90.7462C78.6103 90.8516 78.6103 91.0223 78.5056 91.1277C78.4549 91.1792 78.3849 91.2069 78.3129 91.204Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M78.2954 90.9342L82.9956 86.1035L78.2954 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M78.313 91.2042C78.2431 91.2047 78.1758 91.1773 78.1261 91.1279C78.0214 91.0225 78.0214 90.8518 78.1261 90.7463L82.7971 85.9157C82.9014 85.8154 83.066 85.8159 83.1697 85.917C83.2734 86.018 83.279 86.1834 83.1824 86.2913L78.5115 91.122C78.4591 91.1754 78.3875 91.205 78.313 91.2042Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M82.9956 90.9342L78.2954 86.1035L82.9956 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    d: "M82.9839 91.2038C82.9114 91.2031 82.8421 91.1736 82.7912 91.1217L78.1202 86.291C78.0703 86.2414 78.0422 86.1737 78.0422 86.1032C78.0422 86.0326 78.0703 85.965 78.1202 85.9153C78.2251 85.8101 78.3949 85.8101 78.4998 85.9153L83.1707 90.746C83.2723 90.8527 83.2723 91.0208 83.1707 91.1275C83.121 91.1769 83.0538 91.2044 82.9839 91.2038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    d: "M82.9956 90.9342L87.6958 86.1035L82.9956 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    d: "M82.984 91.2038C82.9139 91.2051 82.8465 91.1775 82.7971 91.1275C82.6956 91.0208 82.6956 90.8527 82.7971 90.746L87.4973 85.9153C87.6021 85.8101 87.772 85.8101 87.8768 85.9153C87.9267 85.965 87.9548 86.0326 87.9548 86.1032C87.9548 86.1737 87.9267 86.2414 87.8768 86.291L83.2058 91.1217C83.148 91.1813 83.0665 91.2115 82.984 91.2038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    d: "M87.6958 90.9342L82.9956 86.1035L87.6958 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M87.6958 91.2042C87.6233 91.2034 87.5541 91.1739 87.5032 91.122L82.803 86.2913C82.7064 86.1834 82.7121 86.018 82.8157 85.917C82.9194 85.8159 83.084 85.8154 83.1883 85.9157L87.8593 90.7463C87.964 90.8518 87.964 91.0225 87.8593 91.1279C87.8155 91.1719 87.7576 91.1989 87.6958 91.2042Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    d: "M87.6958 90.9342L92.3901 86.1035L87.6958 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    d: "M87.6958 91.204C87.6257 91.2053 87.5583 91.1777 87.5089 91.1277C87.4043 91.0223 87.4043 90.8516 87.5089 90.7462L92.1799 85.9156C92.2862 85.8322 92.4375 85.8409 92.5336 85.936C92.6297 86.0311 92.6407 86.1831 92.5594 86.2912L87.8593 91.1219C87.8157 91.1672 87.758 91.1962 87.6958 91.204Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    d: "M92.3901 90.9342L87.6958 86.1035L92.3901 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    d: "M92.3902 91.204C92.3194 91.2031 92.2521 91.1734 92.2033 91.1219L87.5324 86.2912C87.451 86.1831 87.4621 86.0311 87.5582 85.936C87.6543 85.8409 87.8056 85.8322 87.9119 85.9156L92.612 90.7462C92.7167 90.8516 92.7167 91.0223 92.612 91.1277C92.5546 91.1876 92.472 91.216 92.3902 91.204Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    d: "M92.3901 90.9342L97.0903 86.1035L92.3901 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    d: "M92.3901 91.2042C92.3202 91.2047 92.253 91.1773 92.2033 91.1279C92.0986 91.0225 92.0986 90.8518 92.2033 90.7463L96.8742 85.9157C96.9786 85.8154 97.1432 85.8159 97.2468 85.917C97.3505 86.018 97.3561 86.1834 97.2596 86.2913L92.5594 91.122C92.5144 91.1686 92.4544 91.1977 92.3901 91.2042Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    d: "M97.0903 90.9342L92.3901 86.1035L97.0903 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    d: "M97.0903 91.2038C97.0178 91.2031 96.9486 91.1736 96.8977 91.1217L92.2267 86.291C92.1768 86.2414 92.1487 86.1737 92.1487 86.1032C92.1487 86.0326 92.1768 85.965 92.2267 85.9153C92.3315 85.8101 92.5014 85.8101 92.6062 85.9153L97.3064 90.746C97.4079 90.8527 97.4079 91.0208 97.3064 91.1275C97.2498 91.1848 97.1702 91.2129 97.0903 91.2038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    d: "M103.811 90.9342L108.511 86.1035L103.811 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    d: "M103.811 91.2042C103.741 91.2047 103.674 91.1773 103.624 91.1279C103.519 91.0225 103.519 90.8518 103.624 90.7463L108.295 85.9157C108.399 85.8154 108.564 85.8159 108.667 85.917C108.771 86.018 108.777 86.1834 108.68 86.2913L104.003 91.122C103.953 91.1739 103.883 91.2034 103.811 91.2042Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    d: "M108.511 90.9342L103.811 86.1035L108.511 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    d: "M108.511 91.2038C108.438 91.2031 108.369 91.1736 108.318 91.1217L103.647 86.291C103.597 86.2414 103.569 86.1737 103.569 86.1032C103.569 86.0326 103.597 85.965 103.647 85.9153C103.752 85.8101 103.922 85.8101 104.027 85.9153L108.727 90.746C108.828 90.8527 108.828 91.0208 108.727 91.1275C108.671 91.1856 108.591 91.2138 108.511 91.2038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    d: "M108.511 90.9342L113.211 86.1035L108.511 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    d: "M108.511 91.2038C108.441 91.2044 108.374 91.1769 108.324 91.1275C108.222 91.0208 108.222 90.8527 108.324 90.746L113.024 85.9153C113.129 85.8101 113.299 85.8101 113.404 85.9153C113.454 85.965 113.482 86.0326 113.482 86.1032C113.482 86.1737 113.454 86.2414 113.404 86.291L108.733 91.1217C108.675 91.1813 108.593 91.2115 108.511 91.2038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    d: "M113.211 90.9342L108.511 86.1035L113.211 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    d: "M113.211 91.2042C113.138 91.2034 113.069 91.1739 113.018 91.122L108.318 86.2913C108.222 86.1834 108.227 86.018 108.331 85.917C108.435 85.8159 108.599 85.8154 108.703 85.9157L113.374 90.7463C113.479 90.8518 113.479 91.0225 113.374 91.1279C113.331 91.1719 113.273 91.1989 113.211 91.2042Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M113.211 90.9342L117.905 86.1035L113.211 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M113.211 91.204C113.141 91.2053 113.074 91.1777 113.024 91.1277C112.923 91.0211 112.923 90.8529 113.024 90.7462L117.724 85.9156C117.831 85.8322 117.982 85.8409 118.078 85.936C118.174 86.0311 118.185 86.1831 118.104 86.2912L113.433 91.1219C113.377 91.1847 113.294 91.2156 113.211 91.204Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    d: "M117.905 90.9342L113.211 86.1035L117.905 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    d: "M117.905 91.2038C117.835 91.2016 117.768 91.1721 117.718 91.1216L113.018 86.291C112.917 86.1863 112.917 86.02 113.018 85.9153C113.068 85.8652 113.135 85.8369 113.205 85.8369C113.275 85.8369 113.343 85.8652 113.392 85.9153L118.063 90.746C118.168 90.8514 118.168 91.0221 118.063 91.1275C118.021 91.1716 117.965 91.1987 117.905 91.2038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    d: "M117.905 90.9342L122.605 86.1035L117.905 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    d: "M117.905 91.2038C117.837 91.2048 117.771 91.1772 117.724 91.1275C117.673 91.0777 117.643 91.0088 117.643 90.9368C117.643 90.8647 117.673 90.7958 117.724 90.746L122.395 85.9153C122.445 85.8652 122.512 85.8369 122.582 85.8369C122.652 85.8369 122.72 85.8652 122.769 85.9153C122.87 86.02 122.87 86.1863 122.769 86.291L118.069 91.1216C118.025 91.167 117.968 91.196 117.905 91.2038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    d: "M122.605 90.9342L117.905 86.1035L122.605 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    d: "M122.605 91.2038C122.534 91.2042 122.466 91.1744 122.419 91.1216L117.748 86.291C117.696 86.2422 117.667 86.1743 117.667 86.1032C117.667 86.0321 117.696 85.9641 117.748 85.9153C117.797 85.8652 117.864 85.8369 117.934 85.8369C118.005 85.8369 118.072 85.8652 118.121 85.9153L122.821 90.746C122.923 90.8527 122.923 91.0208 122.821 91.1275C122.765 91.1856 122.685 91.2138 122.605 91.2038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    d: "M122.605 90.9342L127.306 86.1035L122.605 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    d: "M122.605 91.2042C122.536 91.2047 122.468 91.1773 122.419 91.1279C122.314 91.0225 122.314 90.8518 122.419 90.7463L127.09 85.9157C127.194 85.8154 127.359 85.8159 127.462 85.917C127.566 86.018 127.571 86.1834 127.475 86.2913L122.775 91.122C122.73 91.1686 122.67 91.1977 122.605 91.2042Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    d: "M127.306 90.9342L122.605 86.1035L127.306 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    d: "M127.306 91.2038C127.233 91.2031 127.164 91.1736 127.113 91.1217L122.442 86.291C122.392 86.2414 122.364 86.1737 122.364 86.1032C122.364 86.0326 122.392 85.965 122.442 85.9153C122.547 85.8101 122.717 85.8101 122.822 85.9153L127.522 90.746C127.623 90.8527 127.623 91.0208 127.522 91.1275C127.465 91.1848 127.386 91.2129 127.306 91.2038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    d: "M127.306 90.9342L132.006 86.1035L127.306 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    d: "M127.306 91.2038C127.235 91.205 127.168 91.1775 127.119 91.1275C127.017 91.0208 127.017 90.8527 127.119 90.746L131.79 85.9153C131.839 85.8652 131.906 85.8369 131.976 85.8369C132.047 85.8369 132.114 85.8652 132.163 85.9153C132.215 85.9641 132.244 86.0321 132.244 86.1032C132.244 86.1743 132.215 86.2422 132.163 86.291L127.492 91.1216C127.443 91.1721 127.376 91.2016 127.306 91.2038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    d: "M132.006 90.9342L127.306 86.1035L132.006 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    d: "M132.029 91.2042C131.957 91.2034 131.887 91.1739 131.837 91.122L127.166 86.2913C127.069 86.1834 127.075 86.018 127.178 85.917C127.282 85.8159 127.447 85.8154 127.551 85.9157L132.222 90.7463C132.274 90.7962 132.303 90.8651 132.303 90.9371C132.303 91.0091 132.274 91.078 132.222 91.1279C132.172 91.1807 132.101 91.2086 132.029 91.2042Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    d: "M132.006 90.9342L136.7 86.1035L132.006 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    d: "M132.029 91.2038C131.959 91.205 131.892 91.1775 131.842 91.1275C131.738 91.0221 131.738 90.8514 131.842 90.746L136.542 85.9153C136.592 85.8652 136.659 85.8369 136.729 85.8369C136.799 85.8369 136.867 85.8652 136.916 85.9153C137.017 86.02 137.017 86.1863 136.916 86.291L132.245 91.1216C132.189 91.1797 132.11 91.2097 132.029 91.2038Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    d: "M136.7 90.9342L132.006 86.1035L136.7 90.9342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    d: "M136.7 91.204C136.629 91.2045 136.561 91.1746 136.513 91.1219L131.813 86.2912C131.732 86.1831 131.743 86.0311 131.839 85.936C131.935 85.8409 132.086 85.8322 132.193 85.9156L136.864 90.7462C136.965 90.8529 136.965 91.0211 136.864 91.1277C136.82 91.1722 136.762 91.1993 136.7 91.204Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    d: "M142.113 86.1855H58.8877C58.817 86.1871 58.7487 86.16 58.6981 86.1103C58.6476 86.0605 58.6191 85.9925 58.6191 85.9214C58.6191 85.7723 58.7394 85.6514 58.8877 85.6514H142.113C142.261 85.6514 142.381 85.7723 142.381 85.9214C142.381 85.9925 142.353 86.0605 142.302 86.1103C142.252 86.16 142.183 86.1871 142.113 86.1855Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 62.2742,
    y: 132.121,
    width: 76.4462,
    height: 2.67065,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.274 135.044H138.726C138.869 135.044 138.986 134.929 138.989 134.785V132.109C138.989 131.963 138.871 131.845 138.726 131.845H62.274C62.1289 131.845 62.0112 131.963 62.0112 132.109V134.78C62.0112 134.925 62.1289 135.044 62.274 135.044ZM138.452 134.527H62.5484V132.391H138.452V134.527Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    d: "M138.726 134.797V150.645H129.571C129.571 150.645 123.318 136.441 100.5 136.441C77.6825 136.441 71.4293 150.645 71.4293 150.645H62.2742V134.797H138.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.571 150.892H138.726C138.874 150.892 138.995 150.771 138.995 150.622V134.774C138.995 134.702 138.966 134.634 138.916 134.583C138.866 134.532 138.797 134.504 138.726 134.504H62.274C62.2027 134.504 62.1344 134.532 62.084 134.583C62.0337 134.634 62.0054 134.702 62.0054 134.774V150.622C62.0054 150.693 62.0337 150.762 62.084 150.813C62.1344 150.863 62.2027 150.892 62.274 150.892H71.429C71.5338 150.889 71.6284 150.828 71.6743 150.733C71.7327 150.592 78.1377 136.682 100.5 136.682C122.862 136.682 129.267 150.592 129.326 150.733C129.372 150.828 129.466 150.889 129.571 150.892ZM138.452 150.358H129.74V150.381C128.946 148.802 121.922 136.153 100.506 136.153C79.0894 136.153 72.0596 148.785 71.2656 150.363H62.5484V135.044H138.452V150.358Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 59.3489,
    y: 90.9341,
    width: 82.3025,
    height: 2.44761,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3256 93.6752H141.651C141.731 93.6753 141.807 93.6427 141.862 93.5851C141.917 93.5275 141.947 93.4498 141.943 93.37V90.9341C141.943 90.772 141.813 90.6406 141.651 90.6406H59.3256C59.1644 90.6406 59.0337 90.772 59.0337 90.9341V93.3817C59.0337 93.5438 59.1644 93.6752 59.3256 93.6752ZM141.371 93.0882H59.6409L59.6292 91.2276H141.371V93.0882Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    d: "M97.1895 84.9351L100.5 82.6401L103.811 84.9351V90.9338H97.1895V84.9351Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.9209 90.9341C96.9209 91.0832 97.0411 91.2041 97.1895 91.2041H103.811C103.959 91.2041 104.079 91.0832 104.079 90.9341V84.9354C104.079 84.8462 104.036 84.7628 103.962 84.7124L100.652 82.4174C100.559 82.3589 100.441 82.3589 100.348 82.4174L97.0377 84.7124C96.9645 84.7628 96.9208 84.8462 96.9209 84.9354V90.9341ZM103.548 85.0763V90.67H97.4522V85.0763L100.5 82.9632L103.548 85.0763Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    d: "M97.1896 89.6307C97.1189 89.6323 97.0506 89.6051 97.0001 89.5554C96.9495 89.5057 96.921 89.4376 96.921 89.3666V83.3327C96.9055 83.2278 96.9525 83.1235 97.0411 83.066C97.1298 83.0086 97.2436 83.0086 97.3323 83.066C97.4209 83.1235 97.4679 83.2278 97.4524 83.3327V89.3666C97.4524 89.5124 97.3347 89.6307 97.1896 89.6307Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    d: "M103.811 89.6307C103.666 89.6307 103.548 89.5124 103.548 89.3666V83.3327C103.532 83.2278 103.579 83.1235 103.668 83.066C103.757 83.0086 103.871 83.0086 103.959 83.066C104.048 83.1235 104.095 83.2278 104.079 83.3327V89.3666C104.079 89.4376 104.051 89.5057 104 89.5554C103.95 89.6051 103.881 89.6323 103.811 89.6307Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    d: "M100.5 82.9101C100.353 82.907 100.235 82.7879 100.232 82.6401V80.9731C100.232 80.824 100.352 80.7031 100.5 80.7031C100.649 80.7031 100.769 80.824 100.769 80.9731V82.6401C100.766 82.7879 100.647 82.907 100.5 82.9101Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    d: "M10.3212 132.109V116.431C29.0051 113.303 47.689 90.394 47.689 90.394L46.6614 94.9077C46.6614 94.9077 27.633 116.525 10.3096 118.539",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0293 132.121C10.0293 132.283 10.16 132.414 10.3212 132.414C10.4007 132.414 10.4768 132.382 10.5319 132.324C10.587 132.267 10.6163 132.189 10.6132 132.109V118.803C27.7848 116.619 46.7022 95.3245 46.8891 95.1073C46.9247 95.0722 46.9491 95.0273 46.9591 94.9782L47.9809 90.4645C48.0075 90.3333 47.9459 90.2 47.8291 90.1358C47.7057 90.0781 47.559 90.112 47.4729 90.218C47.4711 90.2202 47.4676 90.2244 47.4623 90.2308C46.923 90.8798 28.4585 113.104 10.2745 116.144C10.133 116.169 10.0299 116.293 10.0293 116.437V118.539V132.121ZM10.6132 118.204V116.678C26.9791 113.79 43.4326 95.7765 47.1518 91.4917L46.4045 94.7669C45.3243 95.976 27.1192 116.056 10.6132 118.204Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    d: "M15.9731 132.391C15.9024 132.391 15.8346 132.362 15.7852 132.311C15.7358 132.261 15.7088 132.192 15.7103 132.121V117.247C15.7299 117.115 15.8429 117.017 15.976 117.017C16.1091 117.017 16.2221 117.115 16.2417 117.247V132.109C16.2466 132.183 16.2203 132.256 16.1692 132.31C16.1181 132.363 16.0469 132.393 15.9731 132.391Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    d: "M22.0163 132.391C21.9446 132.393 21.8753 132.365 21.8246 132.314C21.7739 132.263 21.7461 132.193 21.7477 132.121V114.682C21.7673 114.55 21.8803 114.452 22.0134 114.452C22.1464 114.452 22.2594 114.55 22.279 114.682V132.109C22.2839 132.182 22.2583 132.254 22.2085 132.307C22.1587 132.361 22.0891 132.391 22.0163 132.391Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    d: "M28.3277 132.391C28.2565 132.391 28.1882 132.362 28.1378 132.312C28.0874 132.261 28.0591 132.192 28.0591 132.121V110.978C28.0591 110.829 28.1794 110.708 28.3277 110.708C28.476 110.708 28.5963 110.829 28.5963 110.978V132.109C28.5995 132.183 28.5726 132.254 28.5219 132.307C28.4711 132.361 28.401 132.391 28.3277 132.391Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    d: "M34.6393 132.391C34.5686 132.391 34.5009 132.362 34.4515 132.311C34.402 132.261 34.375 132.192 34.3766 132.121V106.283C34.3962 106.151 34.5092 106.053 34.6423 106.053C34.7753 106.053 34.8884 106.151 34.9079 106.283V132.109C34.9129 132.183 34.8866 132.256 34.8355 132.31C34.7844 132.363 34.7132 132.393 34.6393 132.391Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    d: "M54.7773 53.2865C54.6312 53.2866 54.5119 53.1692 54.5087 53.0224V47.6929C54.5087 47.5437 54.629 47.4229 54.7773 47.4229C54.9256 47.4229 55.0459 47.5437 55.0459 47.6929V53.0224C55.0427 53.1692 54.9234 53.2866 54.7773 53.2865Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    d: "M54.0298 54.4312H55.5245L62.0055 81.2198H47.5488L54.0298 54.4312Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5547 81.5075H62.0055C62.0983 81.5098 62.1868 81.4686 62.2449 81.396C62.2992 81.3263 62.3186 81.2354 62.2975 81.1494L55.8223 54.3666C55.7947 54.2332 55.6777 54.1376 55.5421 54.1377H54.0299C53.8936 54.1392 53.7758 54.2335 53.7438 54.3666L47.2686 81.1494C47.2475 81.2354 47.2669 81.3263 47.3212 81.396C47.3781 81.4669 47.4641 81.508 47.5547 81.5075ZM61.6319 80.9205H47.9226L54.2576 54.7247H55.2969L61.6319 80.9205Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 54.0356,
    y: 52.4238,
    width: 1.48887,
    height: 2.00739,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.059 54.7247H55.5421C55.7033 54.7247 55.834 54.5933 55.834 54.4312V52.4238C55.834 52.2618 55.7033 52.1304 55.5421 52.1304H54.059C53.8978 52.1304 53.7671 52.2618 53.7671 52.4238V54.4312C53.7671 54.5933 53.8978 54.7247 54.059 54.7247ZM55.2735 54.1378H54.3743V52.7173H55.2735V54.1378Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    d: "M57.9359 80.3391V73.9941L54.7771 68.6528L51.6184 73.9941V80.3391H48.5823V131.117H60.972V80.3391H57.9359Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5882 131.387H60.9721C61.1159 131.384 61.2317 131.267 61.2348 131.123V80.3451C61.2348 80.1992 61.1172 80.0809 60.9721 80.0809H58.1987V74.0001C58.199 73.9528 58.1869 73.9062 58.1636 73.8651L55.0049 68.5238C54.9539 68.4476 54.8686 68.4019 54.7772 68.4019C54.6858 68.4019 54.6005 68.4476 54.5495 68.5238L51.3907 73.8651C51.3675 73.9062 51.3554 73.9528 51.3557 74.0001V80.0751H48.5882C48.5175 80.0735 48.4491 80.1006 48.3986 80.1503C48.348 80.2 48.3196 80.2681 48.3196 80.3392V131.117C48.3196 131.266 48.4398 131.387 48.5882 131.387ZM60.7035 130.847H48.8509L48.7925 80.6092H51.5601C51.7084 80.6092 51.8286 80.4883 51.8286 80.3392V74.0646L54.748 69.1753L57.6674 74.0646V80.3392C57.6705 80.487 57.7889 80.6061 57.9359 80.6092H60.7035V130.847Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    d: "M60.972 85.2583H48.5881C48.4838 85.2739 48.3801 85.2267 48.3229 85.1376C48.2657 85.0485 48.2657 84.934 48.3229 84.8449C48.3801 84.7558 48.4838 84.7086 48.5881 84.7242H60.972C61.1036 84.7438 61.2011 84.8574 61.2011 84.9912C61.2011 85.125 61.1036 85.2386 60.972 85.2583Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    d: "M52.5876 94.9369H50.6316V88.5743C50.6316 88.0284 51.6125 87.1479 51.6125 87.1479C51.6125 87.1479 52.5876 88.0284 52.5876 88.5743V94.9369Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    d: "M55.7582 94.9369H53.7905V88.5743C53.7905 88.0284 54.7714 87.1479 54.7714 87.1479C54.7714 87.1479 55.7523 88.0284 55.7523 88.5743L55.7582 94.9369Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    d: "M58.9228 94.9369H56.9668V88.5743C56.9668 88.0284 57.9419 87.1479 57.9419 87.1479C57.9419 87.1479 58.9228 88.0284 58.9228 88.5743V94.9369Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    d: "M52.5876 106.87H50.6316V100.478C50.6316 99.9381 51.6125 99.0518 51.6125 99.0518C51.6125 99.0518 52.5876 99.9381 52.5876 100.478V106.87Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    d: "M55.7582 106.87H53.7905V100.478C53.7905 99.9381 54.7714 99.0518 54.7714 99.0518C54.7714 99.0518 55.7523 99.9381 55.7523 100.478L55.7582 106.87Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    d: "M58.9228 106.87H56.9668V100.478C56.9668 99.9381 57.9419 99.0518 57.9419 99.0518C57.9419 99.0518 58.9228 99.9381 58.9228 100.478V106.87Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    d: "M52.5876 118.756H50.6316V112.387C50.6316 111.841 51.6125 110.961 51.6125 110.961C51.6125 110.961 52.5876 111.841 52.5876 112.387V118.756Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    d: "M55.7582 118.756H53.7905V112.387C53.7905 111.841 54.7714 110.961 54.7714 110.961C54.7714 110.961 55.7523 111.841 55.7523 112.387L55.7582 118.756Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    d: "M58.9228 118.756H56.9668V112.387C56.9668 111.841 57.9419 110.961 57.9419 110.961C57.9419 110.961 58.9228 111.841 58.9228 112.387V118.756Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    d: "M60.5284 122.271H49.0261C48.8801 122.272 48.7607 122.154 48.7576 122.007C48.7607 121.86 48.8791 121.74 49.0261 121.737H60.5284C60.6754 121.74 60.7939 121.86 60.797 122.007C60.7938 122.154 60.6745 122.272 60.5284 122.271Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    d: "M46.5271 60.6118L49.4815 71.9225H43.5728L46.5271 60.6118Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5727 72.2392H49.4815C49.5672 72.2339 49.6462 72.191 49.6975 72.1218C49.7546 72.0512 49.7741 71.9572 49.7501 71.8694L46.7957 60.5588C46.7585 60.4277 46.6393 60.3374 46.5038 60.3374C46.3682 60.3374 46.2491 60.4277 46.2118 60.5588L43.2925 71.8694C43.2687 71.9563 43.2859 72.0494 43.3392 72.1218C43.3955 72.1943 43.4813 72.2375 43.5727 72.2392ZM49.1195 71.6523H43.9522L46.5446 61.7855L49.1195 71.6523Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    d: "M44.6353 71.9224L44.7579 90.7754L45.8847 93.7924V131.117H49.5106V93.4108L48.6289 91.4328V71.9224H44.6353Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8848 131.387H49.5107C49.6554 131.381 49.7705 131.263 49.7734 131.117V93.4108C49.7794 93.3759 49.7794 93.3401 49.7734 93.3052L48.9151 91.3741V71.9223C48.9151 71.7732 48.7949 71.6523 48.6465 71.6523H44.6529C44.5831 71.6524 44.5161 71.6798 44.466 71.7286C44.4144 71.7798 44.385 71.8495 44.3843 71.9223L44.5127 90.7754C44.5071 90.8064 44.5071 90.8382 44.5127 90.8693L45.6162 93.8393V131.117C45.6193 131.265 45.7378 131.384 45.8848 131.387ZM49.2421 130.847H46.1534L46.1592 93.7865C46.1643 93.7554 46.1643 93.7237 46.1592 93.6926L45.0499 90.7226L44.9273 72.1865H48.3838V91.4328C48.3784 91.4698 48.3784 91.5073 48.3838 91.5443L49.2421 93.4695V130.847Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    d: "M48.6289 84.4424H44.717C44.6127 84.458 44.509 84.4107 44.4518 84.3216C44.3946 84.2326 44.3946 84.1181 44.4518 84.029C44.509 83.9399 44.6127 83.8927 44.717 83.9082H48.6289C48.7333 83.8927 48.837 83.9399 48.8941 84.029C48.9513 84.1181 48.9513 84.2326 48.8941 84.3216C48.837 84.4107 48.7333 84.458 48.6289 84.4424Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    d: "M49.5106 94.0566H45.8847C45.7804 94.0722 45.6767 94.025 45.6195 93.9359C45.5624 93.8468 45.5624 93.7323 45.6195 93.6432C45.6767 93.5541 45.7804 93.5069 45.8847 93.5225H49.5106C49.6149 93.5069 49.7186 93.5541 49.7758 93.6432C49.8329 93.7323 49.8329 93.8468 49.7758 93.9359C49.7186 94.025 49.6149 94.0722 49.5106 94.0566Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    d: "M63.0271 60.6118L60.0728 71.9225H65.9815L63.0271 60.6118Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8451 72.1218C59.899 72.1941 59.983 72.2374 60.0728 72.2392H65.9816C66.0792 72.243 66.1726 72.1993 66.2326 72.1218C66.2872 72.05 66.3065 71.9572 66.2852 71.8694L63.3308 60.5588C63.2936 60.4277 63.1744 60.3374 63.0389 60.3374C62.9033 60.3374 62.7842 60.4277 62.7469 60.5588L59.7926 71.8694C59.7685 71.9572 59.7881 72.0512 59.8451 72.1218ZM63.0272 61.7855L65.6021 71.6523H60.4523L63.0272 61.7855Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    d: "M64.919 71.9224L64.7964 90.7754L63.6695 93.7924V131.117H60.0437V93.4108L60.9253 91.4328V71.9224H64.919Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0436 131.387H63.6694C63.8119 131.378 63.9236 131.26 63.9263 131.117V93.8391L65.0357 90.8691C65.0385 90.8379 65.0385 90.8064 65.0357 90.7752L65.1641 71.9221C65.1675 71.8495 65.1403 71.7789 65.0892 71.7275C65.038 71.6761 64.9678 71.6488 64.8956 71.6521H60.9019C60.7535 71.6521 60.6333 71.773 60.6333 71.9221V91.3739L59.775 93.305C59.769 93.3399 59.769 93.3757 59.775 93.4106V131.117C59.7781 131.265 59.8966 131.384 60.0436 131.387ZM63.4008 130.847H60.3122L60.318 93.4693L61.1763 91.5441C61.1846 91.5074 61.1846 91.4693 61.1763 91.4326V72.1863H64.6328L64.5102 90.7224L63.4008 93.6924C63.3958 93.7235 63.3958 93.7552 63.4008 93.7863V130.847Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    d: "M64.8372 84.4424H60.9253C60.8209 84.458 60.7172 84.4107 60.6601 84.3216C60.6029 84.2326 60.6029 84.1181 60.6601 84.029C60.7172 83.9399 60.8209 83.8927 60.9253 83.9082H64.8372C64.9415 83.8927 65.0452 83.9399 65.1024 84.029C65.1596 84.1181 65.1596 84.2326 65.1024 84.3216C65.0452 84.4107 64.9415 84.458 64.8372 84.4424Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    d: "M63.6695 94.0566H60.0437C59.9394 94.0722 59.8356 94.025 59.7785 93.9359C59.7213 93.8468 59.7213 93.7323 59.7785 93.6432C59.8356 93.5541 59.9394 93.5069 60.0437 93.5225H63.6695C63.7738 93.5069 63.8776 93.5541 63.9347 93.6432C63.9919 93.7323 63.9919 93.8468 63.9347 93.9359C63.8776 94.025 63.7738 94.0722 63.6695 94.0566Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    d: "M46.527 61.3454C46.3787 61.3454 46.2585 61.2245 46.2585 61.0754V58.4399C46.2585 58.2908 46.3787 58.1699 46.527 58.1699C46.6754 58.1699 46.7956 58.2908 46.7956 58.4399V61.0871C46.7894 61.2316 46.6709 61.3455 46.527 61.3454Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    d: "M63.0273 61.3455C62.9566 61.3455 62.8889 61.3169 62.8394 61.2661C62.79 61.2153 62.763 61.1466 62.7646 61.0755V58.4401C62.749 58.3352 62.796 58.2309 62.8847 58.1735C62.9733 58.116 63.0872 58.116 63.1758 58.1735C63.2644 58.2309 63.3114 58.3352 63.2959 58.4401V61.0872C63.2943 61.1573 63.2652 61.2239 63.2148 61.2723C63.1644 61.3208 63.097 61.3471 63.0273 61.3455Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    x: 41.8269,
    y: 131.117,
    width: 25.8772,
    height: 19.5339,
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.827 150.892H67.71C67.8476 150.893 67.9636 150.789 67.9785 150.651V131.117C67.9754 130.969 67.857 130.85 67.71 130.847H41.827C41.6809 130.85 41.5642 130.97 41.5642 131.117V150.628C41.5642 150.773 41.6818 150.892 41.827 150.892ZM67.4589 150.381H42.113V131.387H67.4589V150.381Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    d: "M55.7582 81.2137H53.7905V74.8511C53.7905 74.3052 54.7714 73.4248 54.7714 73.4248C54.7714 73.4248 55.7523 74.3052 55.7523 74.8511L55.7582 81.2137Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7905 81.5074H55.7581C55.9171 81.5042 56.0442 81.3737 56.0442 81.2139V74.8513C56.0442 74.2056 55.1451 73.3663 54.9641 73.2078C54.8549 73.1078 54.6879 73.1078 54.5787 73.2078C54.3977 73.3663 53.4985 74.2056 53.4985 74.8513V81.2139C53.4985 81.376 53.6292 81.5074 53.7905 81.5074ZM55.4662 80.9204H54.0882V74.8513C54.2211 74.4541 54.4593 74.101 54.7772 73.83C55.0951 74.101 55.3333 74.4541 55.4662 74.8513V80.9204Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    x: 10.3213,
    y: 132.121,
    width: 31.5057,
    height: 2.67065,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2979 135.044H41.8269C41.8966 135.045 41.9641 135.019 42.0144 134.971C42.0648 134.922 42.094 134.856 42.0955 134.785V132.109C42.0955 132.038 42.067 131.97 42.0165 131.92C41.966 131.87 41.8976 131.843 41.8269 131.845H10.2979C10.2282 131.845 10.1614 131.873 10.1121 131.922C10.0628 131.972 10.0352 132.039 10.0352 132.109V134.78C10.0352 134.925 10.1528 135.044 10.2979 135.044ZM41.5642 134.527H10.584V132.391H41.5642V134.527Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    x: 10.3213,
    y: 134.797,
    width: 31.5057,
    height: 15.8537,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2977 150.891H41.8268C41.8974 150.893 41.9658 150.866 42.0163 150.816C42.0669 150.766 42.0953 150.698 42.0953 150.627V134.779C42.0969 134.707 42.0692 134.638 42.0184 134.587C41.9677 134.536 41.8985 134.508 41.8268 134.509H10.2977C10.227 134.509 10.1593 134.538 10.1098 134.589C10.0604 134.64 10.0334 134.708 10.035 134.779V150.627C10.035 150.773 10.1526 150.891 10.2977 150.891ZM41.564 150.381H10.5838V135.043H41.564V150.381Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    d: "M40.9452 132.391C40.8735 132.392 40.8043 132.364 40.7536 132.313C40.7028 132.262 40.6751 132.193 40.6767 132.121V100.724C40.6612 100.619 40.7081 100.515 40.7968 100.458C40.8854 100.4 40.9993 100.4 41.0879 100.458C41.1765 100.515 41.2235 100.619 41.208 100.724V132.109C41.2128 132.182 41.1873 132.254 41.1375 132.307C41.0877 132.36 41.0181 132.391 40.9452 132.391Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    d: "M190.679 132.109V116.431C171.995 113.303 153.311 90.394 153.311 90.394L154.339 94.9077C154.339 94.9077 173.367 116.525 190.691 118.539",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.387 132.121C190.387 132.283 190.518 132.414 190.679 132.414C190.764 132.423 190.847 132.394 190.909 132.336C190.971 132.277 191.004 132.194 191 132.109V118.509V116.408C191 116.264 190.896 116.14 190.755 116.115C172.571 113.075 154.106 90.8504 153.567 90.2015C153.562 90.1951 153.558 90.1909 153.557 90.1887C153.47 90.0827 153.324 90.0488 153.2 90.1065C153.084 90.1708 153.022 90.304 153.049 90.4352L154.041 94.9724C154.051 95.0215 154.076 95.0664 154.111 95.1015C154.298 95.3187 173.216 116.613 190.387 118.797V132.121ZM190.387 118.204C173.864 116.056 155.676 95.9761 154.596 94.7669L153.849 91.4917C157.568 95.7765 174.039 113.79 190.387 116.678V118.204Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    d: "M185.027 132.391C184.955 132.392 184.886 132.365 184.835 132.314C184.785 132.263 184.757 132.193 184.758 132.121V117.247C184.778 117.115 184.891 117.017 185.024 117.017C185.157 117.017 185.27 117.115 185.29 117.247V132.109C185.295 132.182 185.269 132.254 185.219 132.307C185.169 132.361 185.1 132.391 185.027 132.391Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    d: "M178.984 132.391C178.914 132.386 178.849 132.354 178.803 132.301C178.757 132.248 178.734 132.179 178.739 132.109V114.682C178.758 114.55 178.871 114.452 179.005 114.452C179.138 114.452 179.251 114.55 179.27 114.682V132.109C179.276 132.187 179.247 132.262 179.192 132.317C179.137 132.371 179.061 132.398 178.984 132.391Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    d: "M172.672 132.391C172.601 132.391 172.533 132.362 172.483 132.312C172.432 132.261 172.404 132.192 172.404 132.121V110.978C172.404 110.829 172.524 110.708 172.672 110.708C172.821 110.708 172.941 110.829 172.941 110.978V132.109C172.944 132.183 172.917 132.254 172.867 132.307C172.816 132.361 172.746 132.391 172.672 132.391Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    d: "M166.361 132.391C166.289 132.392 166.22 132.365 166.169 132.314C166.118 132.263 166.091 132.193 166.092 132.121V106.283C166.112 106.151 166.225 106.053 166.358 106.053C166.491 106.053 166.604 106.151 166.623 106.283V132.109C166.628 132.182 166.603 132.254 166.553 132.307C166.503 132.361 166.434 132.391 166.361 132.391Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    d: "M146.223 53.2865C146.077 53.2866 145.958 53.1692 145.955 53.0224V47.6929C145.955 47.5437 146.075 47.4229 146.223 47.4229C146.371 47.4229 146.492 47.5437 146.492 47.6929V53.0224C146.488 53.1692 146.369 53.2866 146.223 53.2865Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    d: "M146.97 54.4312H145.47L138.995 81.2198H153.451L146.97 54.4312Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.995 81.5075H153.446C153.536 81.508 153.622 81.4669 153.679 81.396C153.733 81.3263 153.753 81.2354 153.732 81.1494L147.256 54.3666C147.224 54.2335 147.107 54.1392 146.97 54.1377H145.47C145.334 54.1376 145.217 54.2332 145.19 54.3666L138.714 81.1494C138.693 81.2354 138.713 81.3263 138.767 81.396C138.823 81.4653 138.906 81.5062 138.995 81.5075ZM153.078 80.9205H139.368L145.703 54.7247H146.743L153.078 80.9205Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    x: 146.965,
    y: 54.437,
    width: 1.48887,
    height: 2.00739,
    transform: "rotate(-180 146.965 54.437)",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.458 54.7247H146.965C147.117 54.7125 147.234 54.5846 147.233 54.4312V52.4238C147.233 52.2618 147.102 52.1304 146.941 52.1304H145.458C145.297 52.1304 145.166 52.2618 145.166 52.4238V54.4312C145.166 54.5933 145.297 54.7247 145.458 54.7247ZM146.696 54.1378H145.797V52.7173H146.696V54.1378Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    d: "M143.064 80.3391V73.9941L146.223 68.6528L149.382 73.9941V80.3391H152.418V131.117H140.028V80.3391H143.064Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.028 131.387H152.412C152.558 131.387 152.677 131.27 152.681 131.123V80.3451C152.681 80.274 152.652 80.2059 152.602 80.1562C152.551 80.1065 152.483 80.0794 152.412 80.0809H149.644V74.0001C149.645 73.9528 149.633 73.9062 149.609 73.8651L146.451 68.5238C146.4 68.4476 146.314 68.4019 146.223 68.4019C146.132 68.4019 146.046 68.4476 145.995 68.5238L142.837 73.8651C142.813 73.9062 142.801 73.9528 142.802 74.0001V80.0751H140.028C139.883 80.0751 139.765 80.1933 139.765 80.3392V131.117C139.765 131.264 139.882 131.384 140.028 131.387ZM152.149 130.847H140.297V80.6092H143.064C143.211 80.6061 143.33 80.487 143.333 80.3392V74.0646L146.223 69.1753L149.113 74.0646V80.3392C149.113 80.4883 149.233 80.6092 149.382 80.6092H152.149V130.847Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    d: "M152.412 85.2583H140.028C139.897 85.2386 139.799 85.125 139.799 84.9912C139.799 84.8574 139.897 84.7438 140.028 84.7242H152.412C152.516 84.7086 152.62 84.7558 152.677 84.8449C152.734 84.934 152.734 85.0485 152.677 85.1376C152.62 85.2267 152.516 85.2739 152.412 85.2583Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    d: "M148.413 94.9369H150.369V88.5743C150.369 88.0284 149.388 87.1479 149.388 87.1479C149.388 87.1479 148.413 88.0284 148.413 88.5743V94.9369Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    d: "M145.242 94.9369H147.21V88.5743C147.21 88.0284 146.229 87.1479 146.229 87.1479C146.229 87.1479 145.248 88.0284 145.248 88.5743L145.242 94.9369Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    d: "M142.078 94.9369H144.034V88.5743C144.034 88.0284 143.059 87.1479 143.059 87.1479C143.059 87.1479 142.078 88.0284 142.078 88.5743V94.9369Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    d: "M148.413 106.87H150.369V100.478C150.369 99.9381 149.388 99.0518 149.388 99.0518C149.388 99.0518 148.413 99.9381 148.413 100.478V106.87Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    d: "M145.242 106.87H147.21V100.478C147.21 99.9381 146.229 99.0518 146.229 99.0518C146.229 99.0518 145.248 99.9381 145.248 100.478L145.242 106.87Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    d: "M142.078 106.87H144.034V100.478C144.034 99.9381 143.059 99.0518 143.059 99.0518C143.059 99.0518 142.078 99.9381 142.078 100.478V106.87Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    d: "M148.413 118.756H150.369V112.387C150.369 111.841 149.388 110.961 149.388 110.961C149.388 110.961 148.413 111.841 148.413 112.387V118.756Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    d: "M145.242 118.756H147.21V112.387C147.21 111.841 146.229 110.961 146.229 110.961C146.229 110.961 145.248 111.841 145.248 112.387L145.242 118.756Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    d: "M142.078 118.756H144.034V112.387C144.034 111.841 143.059 110.961 143.059 110.961C143.059 110.961 142.078 111.841 142.078 112.387V118.756Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    d: "M151.49 97.4785H140.98C140.833 97.4754 140.715 97.3563 140.711 97.2085C140.715 97.0617 140.834 96.9443 140.98 96.9444H151.49C151.636 96.9443 151.755 97.0617 151.758 97.2085C151.755 97.3563 151.637 97.4754 151.49 97.4785Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    d: "M151.49 109.611H140.98C140.876 109.626 140.772 109.579 140.715 109.49C140.658 109.401 140.658 109.287 140.715 109.197C140.772 109.108 140.876 109.061 140.98 109.077H151.49C151.594 109.061 151.698 109.108 151.755 109.197C151.812 109.287 151.812 109.401 151.755 109.49C151.698 109.579 151.594 109.626 151.49 109.611Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    d: "M151.974 122.271H140.472C140.326 122.272 140.207 122.154 140.203 122.007C140.206 121.86 140.325 121.74 140.472 121.737H151.974C152.121 121.74 152.24 121.86 152.243 122.007C152.24 122.154 152.12 122.272 151.974 122.271Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    d: "M154.473 60.6118L151.519 71.9225H157.428L154.473 60.6118Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.519 72.2393H157.428C157.527 72.2357 157.619 72.183 157.673 72.0984C157.726 72.0259 157.743 71.9329 157.72 71.846L154.8 60.5353C154.763 60.4043 154.644 60.314 154.508 60.314C154.373 60.314 154.254 60.4043 154.216 60.5353L151.239 71.8695C151.215 71.9572 151.234 72.0512 151.291 72.1219C151.345 72.1941 151.429 72.2374 151.519 72.2393ZM157.031 71.6523H151.881L154.456 61.7856L157.031 71.6523Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    d: "M156.365 71.9224L156.242 90.7754L155.115 93.7924V131.117H151.49V93.4108L152.371 91.4328V71.9224H156.365Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.49 131.387H155.115C155.262 131.384 155.381 131.265 155.384 131.117V93.8393L156.482 90.8693C156.487 90.8382 156.487 90.8064 156.482 90.7754L156.61 71.9223C156.609 71.8495 156.58 71.7798 156.528 71.7286C156.478 71.6798 156.411 71.6524 156.342 71.6523H152.348C152.2 71.6523 152.079 71.7732 152.079 71.9223V91.3741L151.221 93.3052C151.215 93.3401 151.215 93.3759 151.221 93.4108V131.117C151.224 131.265 151.343 131.384 151.49 131.387ZM154.847 130.847H151.758L151.782 93.4695L152.64 91.5443C152.645 91.5073 152.645 91.4698 152.64 91.4328V72.1865H156.079L155.956 90.7226L154.847 93.6926C154.842 93.7237 154.842 93.7554 154.847 93.7865V130.847Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    d: "M156.283 84.4424H152.371C152.267 84.458 152.163 84.4107 152.106 84.3216C152.049 84.2326 152.049 84.1181 152.106 84.029C152.163 83.9399 152.267 83.8927 152.371 83.9082H156.283C156.388 83.8927 156.491 83.9399 156.548 84.029C156.606 84.1181 156.606 84.2326 156.548 84.3216C156.491 84.4107 156.388 84.458 156.283 84.4424Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    d: "M155.115 94.0566H151.489C151.385 94.0722 151.281 94.025 151.224 93.9359C151.167 93.8468 151.167 93.7323 151.224 93.6432C151.281 93.5541 151.385 93.5069 151.489 93.5225H155.115C155.22 93.5069 155.323 93.5541 155.381 93.6432C155.438 93.7323 155.438 93.8468 155.381 93.9359C155.323 94.025 155.22 94.0722 155.115 94.0566Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    d: "M137.973 60.6118L140.927 71.9225H135.019L137.973 60.6118Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.785 72.1218C134.841 72.1943 134.927 72.2375 135.019 72.2392H140.927C141.023 72.243 141.115 72.1991 141.173 72.1218C141.23 72.0512 141.249 71.9572 141.225 71.8694L138.271 60.5588C138.234 60.4277 138.114 60.3374 137.979 60.3374C137.843 60.3374 137.724 60.4277 137.687 60.5588L134.733 71.8694C134.711 71.9572 134.731 72.05 134.785 72.1218ZM137.973 61.7855L140.548 71.6523H135.398L137.973 61.7855Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    d: "M136.081 71.9224L136.204 90.7754L137.331 93.7924V131.117H140.957V93.4108L140.075 91.4328V71.9224H136.081Z",
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.331 131.387H140.956C141.099 131.378 141.211 131.26 141.213 131.117V93.4106C141.219 93.3757 141.219 93.3399 141.213 93.305L140.355 91.3739V71.9221C140.355 71.773 140.235 71.6521 140.087 71.6521H136.093C136.021 71.6488 135.95 71.6761 135.899 71.7275C135.848 71.7789 135.821 71.8495 135.824 71.9221L135.953 90.7752C135.95 90.8064 135.95 90.8379 135.953 90.8691L137.062 93.8391V131.117C137.065 131.265 137.184 131.384 137.331 131.387ZM140.688 130.847H137.599L137.582 93.7863C137.587 93.7552 137.587 93.7235 137.582 93.6924L136.472 90.7224L136.35 72.1863H139.83V91.4326C139.821 91.4693 139.821 91.5074 139.83 91.5441L140.688 93.4693V130.847Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    d: "M140.075 84.4424H136.163C136.059 84.458 135.955 84.4107 135.898 84.3216C135.841 84.2326 135.841 84.1181 135.898 84.029C135.955 83.9399 136.059 83.8927 136.163 83.9082H140.075C140.179 83.8927 140.283 83.9399 140.34 84.029C140.397 84.1181 140.397 84.2326 140.34 84.3216C140.283 84.4107 140.179 84.458 140.075 84.4424Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    d: "M140.957 94.0566H137.331C137.226 94.0722 137.123 94.025 137.066 93.9359C137.008 93.8468 137.008 93.7323 137.066 93.6432C137.123 93.5541 137.226 93.5069 137.331 93.5225H140.957C141.061 93.5069 141.165 93.5541 141.222 93.6432C141.279 93.7323 141.279 93.8468 141.222 93.9359C141.165 94.025 141.061 94.0722 140.957 94.0566Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    d: "M154.473 61.3454C154.334 61.3394 154.222 61.2272 154.216 61.0871V58.4399C154.216 58.2908 154.336 58.1699 154.485 58.1699C154.633 58.1699 154.753 58.2908 154.753 58.4399V61.0871C154.75 61.1587 154.719 61.2262 154.667 61.2747C154.614 61.3231 154.544 61.3485 154.473 61.3454Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    d: "M137.973 61.3455C137.901 61.3471 137.832 61.3192 137.781 61.2682C137.73 61.2172 137.703 61.1476 137.704 61.0755V58.4401C137.689 58.3352 137.736 58.2309 137.824 58.1735C137.913 58.116 138.027 58.116 138.115 58.1735C138.204 58.2309 138.251 58.3352 138.236 58.4401V61.0872C138.232 61.2308 138.116 61.3455 137.973 61.3455Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    x: 133.29,
    y: 131.117,
    width: 25.8772,
    height: 19.5339,
    fill: "#E7816B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.29 150.892H159.173C159.31 150.892 159.424 150.788 159.436 150.651V131.117C159.436 130.97 159.319 130.85 159.173 130.847H133.29C133.143 130.85 133.025 130.969 133.022 131.117V150.628C133.025 150.774 133.144 150.892 133.29 150.892ZM158.887 150.358H133.559V131.387H158.887V150.358Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    d: "M145.242 81.2137H147.21V74.8511C147.21 74.3052 146.229 73.4248 146.229 73.4248C146.229 73.4248 145.248 74.3052 145.248 74.8511L145.242 81.2137Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    x: 190.673,
    y: 134.797,
    width: 31.5057,
    height: 2.67065,
    transform: "rotate(-180 190.673 134.797)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.15 135.044H190.679C190.822 135.044 190.939 134.929 190.942 134.785V132.109C190.942 131.963 190.824 131.845 190.679 131.845H159.15C159.079 131.843 159.011 131.87 158.96 131.92C158.91 131.97 158.881 132.038 158.881 132.109V134.78C158.881 134.851 158.91 134.919 158.96 134.968C159.011 135.018 159.079 135.045 159.15 135.044ZM190.416 134.51H159.436V132.373H190.416V134.51Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    x: 190.673,
    y: 150.645,
    width: 31.5057,
    height: 15.8537,
    transform: "rotate(-180 190.673 150.645)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.15 150.891H190.679C190.824 150.891 190.942 150.773 190.942 150.627V134.779C190.943 134.708 190.916 134.64 190.867 134.589C190.817 134.538 190.75 134.509 190.679 134.509H159.15C159.078 134.508 159.009 134.536 158.958 134.587C158.908 134.638 158.88 134.707 158.881 134.779V150.627C158.881 150.698 158.91 150.766 158.96 150.816C159.011 150.866 159.079 150.893 159.15 150.891ZM190.416 150.357H159.436V135.043H190.416V150.357Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    d: "M160.055 132.391C159.984 132.391 159.916 132.362 159.867 132.311C159.818 132.26 159.791 132.192 159.792 132.121V100.724C159.777 100.619 159.824 100.515 159.912 100.458C160.001 100.4 160.115 100.4 160.203 100.458C160.292 100.515 160.339 100.619 160.323 100.724V132.109C160.328 132.183 160.302 132.256 160.251 132.309C160.2 132.363 160.129 132.392 160.055 132.391Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    d: "M74.2842 151.478C74.1264 151.475 73.9984 151.349 73.9922 151.191C73.9907 151.113 74.02 151.038 74.0736 150.981C74.1273 150.925 74.2009 150.893 74.2783 150.891C77.3508 150.792 80.2298 149.36 82.1723 146.965C82.2244 146.9 82.3002 146.86 82.3825 146.853C82.4648 146.847 82.5456 146.877 82.6043 146.935C84.079 148.467 86.0058 149.48 88.0986 149.823C90.1844 150.137 92.2863 149.366 93.6804 147.775C93.778 147.654 93.952 147.631 94.0774 147.722C97.4755 149.972 102.025 149.204 104.505 145.961C104.563 145.889 104.65 145.847 104.742 145.847C104.834 145.847 104.921 145.889 104.978 145.961C107.413 149.401 112.761 150.328 116.2 147.91C116.322 147.82 116.492 147.844 116.586 147.962C117.487 148.984 118.777 149.573 120.136 149.582C121.492 149.659 122.816 149.143 123.767 148.168C123.833 148.101 123.926 148.069 124.018 148.08C124.109 148.093 124.189 148.147 124.234 148.227C124.616 148.825 125.22 149.244 125.912 149.39C126.604 149.536 127.325 149.396 127.913 149.001C128.043 148.907 128.223 148.933 128.321 149.06C128.367 149.123 128.386 149.202 128.374 149.279C128.362 149.356 128.32 149.425 128.257 149.471C127.544 149.982 126.647 150.162 125.793 149.964C125.059 149.819 124.401 149.415 123.937 148.825C121.71 150.708 118.426 150.583 116.346 148.538C112.767 150.886 107.425 149.976 104.774 146.618C102.093 149.792 97.5096 150.522 93.984 148.338C92.454 149.944 90.2471 150.709 88.0577 150.392C85.9422 150.058 83.9829 149.069 82.4525 147.563C80.402 149.963 77.4413 151.384 74.2959 151.478H74.2842Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    d: "M115.751 154.067C114.617 154.104 113.517 153.681 112.697 152.893C110.216 154.687 106.779 154.255 104.815 151.901C102.613 153.38 99.9463 153.992 97.3239 153.621C97.2196 153.605 97.1316 153.535 97.093 153.436C97.0544 153.337 97.0711 153.226 97.1368 153.143C97.2025 153.06 97.3072 153.018 97.4115 153.034C99.9788 153.408 102.591 152.777 104.71 151.273C104.774 151.227 104.854 151.208 104.932 151.22C105.009 151.237 105.077 151.281 105.124 151.344C105.98 152.463 107.245 153.191 108.638 153.366C110.031 153.542 111.436 153.149 112.54 152.277C112.599 152.224 112.677 152.199 112.756 152.206C112.833 152.214 112.905 152.252 112.954 152.312C113.783 153.21 114.993 153.647 116.2 153.486C117.449 153.291 118.657 152.895 119.78 152.312C119.851 152.281 119.932 152.279 120.004 152.308C120.076 152.336 120.134 152.393 120.165 152.465C120.231 152.612 120.165 152.785 120.019 152.852C118.836 153.447 117.564 153.844 116.253 154.026C116.086 154.048 115.919 154.062 115.751 154.067Z",
    fill: "#D1D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    d: "M81.5768 154.601C81.4325 154.6 81.3109 154.492 81.2907 154.349C81.2696 154.189 81.378 154.041 81.5359 154.014C82.7371 153.829 83.8392 153.237 84.6597 152.336C84.7133 152.279 84.7864 152.245 84.864 152.242C84.9425 152.237 85.0191 152.267 85.0742 152.324C85.6729 152.951 86.4736 153.344 87.3338 153.433C88.169 153.517 88.9863 153.151 89.4824 152.471C89.5355 152.39 89.6255 152.341 89.7218 152.341C89.8166 152.348 89.9049 152.392 89.967 152.465C90.5426 153.252 91.5721 153.553 92.4777 153.198C92.5745 153.153 92.6885 153.164 92.7747 153.227C92.861 153.291 92.9057 153.397 92.8912 153.504C92.8767 153.61 92.8054 153.7 92.7054 153.738C91.6765 154.14 90.5086 153.888 89.7335 153.099C89.0965 153.755 88.2022 154.092 87.2929 154.02C86.3964 153.934 85.5521 153.557 84.8874 152.946C83.9995 153.828 82.8572 154.405 81.6235 154.595L81.5768 154.601Z",
    fill: "#D1D3D4"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_575_2818",
    x1: 0,
    y1: 202,
    x2: 202,
    y2: 202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D0202",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D0202",
    stopOpacity: 0.497569
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurImg3);
export default __webpack_public_path__ + "static/media/our-img3.f2a53b12c71bf439792a729a7307aa1c.svg";
export { ForwardRef as ReactComponent };